function TermoGeral() {
    return (
        <>
          <h3>Termos &amp; Condi&ccedil;&otilde;es</h3>
          <h4>Regulamento Geral do Bol&atilde;o</h4>

          <h5>1- DO CADASTRO:</h5>
          <p>O cadastro na p&aacute;gina do bol&atilde;o &eacute; gratuito.</p>
          <p>Para participar do bol&atilde;o ser&aacute; cobrada uma &uacute;nica taxa de inscri&ccedil;&atilde;o, v&aacute;lida para as duas etapas da competi&ccedil;&atilde;o: <b>Fase de Grupos</b> e <b>Fase Eliminat&oacute;ria</b>. Somente poder&aacute; participar quem estiver cadastrado na p&aacute;gina.</p>
          <p>Os pontos s&oacute; ser&atilde;o contabilizados ap&oacute;s a confirma&ccedil;&atilde;o do pagamento da taxa de participa&ccedil;&atilde;o.</p>
          <p>Os cancelamentos poder&atilde;o ser feitos at&eacute; 24h antes do in&iacute;cio da Copa.</p>

          <h5>2- DO PAGAMENTO:</h5>
          <p>Valor de participa&ccedil;&atilde;o: <b>R$ 50,00</b> (taxa &uacute;nica, v&aacute;lida para toda a Copa).</p>
          <p>N&atilde;o h&aacute; cobran&ccedil;a adicional para a Fase Eliminat&oacute;ria. Quem pagar a taxa de inscri&ccedil;&atilde;o j&aacute; est&aacute; automaticamente inscrito nas duas etapas.</p>
          <p>O pagamento dever&aacute; ser efetuado at&eacute; o in&iacute;cio da Copa (11/06/2026).</p>
          <p>O pagamento dever&aacute; ser feito em uma das op&ccedil;&otilde;es:</p>
          <ul>
            <li>PIX: 01735180874 (Carlos Alberto)</li>
            <li>Esp&eacute;cie: Juca</li>
          </ul>

          <h5>3- DO LAN&Ccedil;AMENTO DOS PALPITES:</h5>
          <p><b>Fase de Grupos:</b> os palpites dever&atilde;o ser lan&ccedil;ados antes do in&iacute;cio do primeiro jogo da Copa (11/06/2026 &agrave;s 16h).</p>
          <p><b>Fase Eliminat&oacute;ria:</b> os palpites dever&atilde;o ser lan&ccedil;ados at&eacute; o hor&aacute;rio de in&iacute;cio do primeiro jogo de cada fase:</p>
          <ul>
            <li>16-avos de Final: 28/Jun &agrave;s 16h</li>
            <li>Oitavas de Final: 04/Jul &agrave;s 14h</li>
            <li>Quartas de Final: 09/Jul &agrave;s 17h</li>
            <li>Semifinal: 14/Jul &agrave;s 16h</li>
            <li>Terceiro Lugar e Final: 18/Jul &agrave;s 18h</li>
          </ul>
          <p>Os palpites tamb&eacute;m poder&atilde;o ser enviados por e-mail para inclus&atilde;o na p&aacute;gina, seguindo o mesmo crit&eacute;rio de prazo.</p>
          <p>Ap&oacute;s o envio, apenas os administradores poder&atilde;o alter&aacute;-los, mediante solicita&ccedil;&atilde;o por e-mail dentro do prazo.</p>
          <p>E-Mail para contato: suporte@bolaodojuca.diasferraz.com</p>

          <h5>4- DA PONTUA&Ccedil;&Atilde;O:</h5>
          <p>A pontua&ccedil;&atilde;o ser&aacute; gerada automaticamente pelo sistema web seguindo regras pr&eacute;-estabelecidas. Ser&aacute; atualizada em at&eacute; 24h ap&oacute;s as partidas.</p>
          <p>Regras de pontua&ccedil;&atilde;o:</p>
          <ul>
            <li>Acertar o placar: 10 pontos;</li>
            <li>Acertar o vencedor e o placar de um dos times: 7 pontos;</li>
            <li>Acertar somente o vencedor sem acertar o placar dos times: 5 pontos;</li>
            <li>Acertar os gols de um dos times sem acertar mais nada: 2 pontos.</li>
          </ul>
          <p>O placar para contagem no bol&atilde;o ser&aacute; sempre o do <b>tempo regulamentar</b>. Na Fase Eliminat&oacute;ria, N&Atilde;O ser&atilde;o considerados gols na prorroga&ccedil;&atilde;o e/ou nos p&ecirc;naltis.</p>

          <h5>5- DO PR&Ecirc;MIO:</h5>
          <p>O valor arrecadado com as inscri&ccedil;&otilde;es ser&aacute; destinado <b>integralmente</b> ao pr&ecirc;mio dos participantes, dividido entre as duas etapas da seguinte forma:</p>
          <ul>
            <li><b>70%</b> do valor total destinado &agrave; <b>Fase de Grupos</b>;</li>
            <li><b>30%</b> do valor total destinado &agrave; <b>Fase Eliminat&oacute;ria</b>.</li>
          </ul>
          <p>Dentro de cada etapa, o pr&ecirc;mio ser&aacute; distribu&iacute;do entre os tr&ecirc;s primeiros colocados:</p>
          <ul>
            <li>1&ordm; lugar: 60% do pr&ecirc;mio da etapa;</li>
            <li>2&ordm; lugar: 25% do pr&ecirc;mio da etapa;</li>
            <li>3&ordm; lugar: 15% do pr&ecirc;mio da etapa.</li>
          </ul>

          <h5>6- DO CRIT&Eacute;RIO DE DESEMPATE:</h5>
          <p>Em caso de empate, ser&aacute; adotado o modelo de <b>divis&atilde;o de pr&ecirc;mios por empate</b> (<i>split tie money</i>).</p>
          <p>Os pr&ecirc;mios de todas as posi&ccedil;&otilde;es disputadas pelos participantes empatados s&atilde;o somados e divididos igualmente entre eles. Os demais colocados recebem normalmente o pr&ecirc;mio de sua posi&ccedil;&atilde;o.</p>
          <p><b>Exemplos pr&aacute;ticos:</b></p>
          <ul>
            <li><b>Empate no 1&ordm; lugar (2 participantes):</b> os pr&ecirc;mios do 1&ordm; (60%) e do 2&ordm; (25%) s&atilde;o somados e divididos &mdash; cada um recebe 42,5%. O 3&ordm; lugar recebe 15% normalmente.</li>
            <li><b>Empate no 2&ordm; lugar (2 participantes):</b> os pr&ecirc;mios do 2&ordm; (25%) e do 3&ordm; (15%) s&atilde;o somados e divididos &mdash; cada um recebe 20%. O 1&ordm; lugar recebe 60% normalmente.</li>
            <li><b>Empate geral (3 participantes no 1&ordm; lugar):</b> os tr&ecirc;s pr&ecirc;mios s&atilde;o somados (100%) e divididos igualmente &mdash; cada um recebe aproximadamente 33,3%.</li>
          </ul>

          <h5>7- DOS VENCEDORES:</h5>
          <p>Ser&atilde;o considerados vencedores, em cada etapa, os tr&ecirc;s palpiteiros com maior n&uacute;mero de pontos ao final de todas as rodadas daquela fase, aplicando-se o crit&eacute;rio de desempate acima quando necess&aacute;rio.</p>
        </>
    );
}

export default TermoGeral;
